import React from 'react'
import Layout from '../Layout'
import DashboardLayout from '../DashboardLayout'
import PreferenceForm from '../../../utils/CommonFunctionality/PreferenceFunction'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const Preference = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const { t } = useTranslation()
    return (
        <Layout props={props}>
            <DashboardLayout title={t('notifi_preference')}>
                <PreferenceForm props={props} notifictionpara={true} />
            </DashboardLayout>
        </Layout>
    )
}

export default Preference
